import { genericRequest } from 'app/api/genericRequest';

export const enableSubscriptionRenew = async (intl) => {
  try {
    await genericRequest({
      url: 'customers/me/actions',
      method: 'POST',
      data: {
        data: {
          type: 'customer-action',
          attributes: {
            type: 'enable-subscription-renew'
          }
        }
      },
      customSuccessFeedback: {
        variant: 'success',
        content: intl.formatMessage({
          id: 'controlpanel.feedback.save_changes.success'
        }),
        autoClose: true,
        dismissible: false
      }
    });

    return true;
  } catch (error) {
    return false;
  }
};
